import { Injectable, Type } from '@angular/core';
import { FieldType } from '../../admin/templates/templates-admin.model';
import { BaseFieldComponent } from './strategies/base-field.component';

/**
 * Registry service for field type strategy components.
 * Use register() to add new field types.
 */
@Injectable({
    providedIn: 'root'
})
export class FieldTypeRegistryService {
    private readonly registry = new Map<FieldType, Type<BaseFieldComponent>>();

    /**
     * Register a field type strategy component.
     * @param fieldType The field type identifier
     * @param component The component class that handles this field type
     */
    register(fieldType: FieldType, component: Type<BaseFieldComponent>): void {
        if (this.registry.has(fieldType)) {
            console.warn(`Field type '${fieldType}' is already registered. Overwriting.`);
        }
        this.registry.set(fieldType, component);
    }

    /**
     * Get the component class for a field type.
     * @param fieldType The field type identifier
     * @returns The component class, or undefined if not registered
     */
    getComponent(fieldType: FieldType): Type<BaseFieldComponent> | undefined {
        return this.registry.get(fieldType);
    }

    /**
     * Check if a field type is registered.
     * @param fieldType The field type identifier
     */
    hasComponent(fieldType: FieldType): boolean {
        return this.registry.has(fieldType);
    }

    /**
     * Get all registered field types.
     */
    getRegisteredTypes(): FieldType[] {
        return Array.from(this.registry.keys());
    }
}
